module.exports = __webpack_public_path__ + "img/user-menu-exit.4f2fe893.svg";